/**
 * Der Stand eines Datensatzes in Worten — für Listen, die Arten mischen:
 * Prüfungen, Feststellungen, Maßnahmen, Berichte, Prüfobjekte, Einträge der
 * Governance. Ein Schlüssel, den die Tabelle nicht kennt, bleibt, wie er ist.
 */
const STAND: Record<string, string> = {
  // Prüfungen
  planning: 'in Planung',
  fieldwork: 'in Durchführung',
  reporting: 'in Berichterstattung',
  review: 'in Durchsicht',
  final: 'abgeschlossen',
  closed: 'geschlossen',
  // Feststellungen
  draft: 'Entwurf',
  confirmed: 'bestätigt',
  disputed: 'strittig',
  resolved: 'erledigt',
  // Maßnahmen
  open: 'offen',
  in_progress: 'in Umsetzung',
  implemented: 'umgesetzt',
  verified: 'verifiziert',
  overdue: 'überfällig',
  escalated: 'eskaliert',
  // Berichte
  approved: 'genehmigt',
  distributed: 'verteilt',
  // Prüfobjekte, Ausgliederungen, Abweichungen, Einschränkungen
  active: 'aktiv',
  inactive: 'inaktiv',
  archived: 'archiviert',
  planned: 'geplant',
  ended: 'beendet',
  terminated: 'gekündigt',
  accepted_by_board: 'vom Aufsichtsorgan hingenommen',
  superseded: 'ersetzt',
};

export const standText = (status: string | null | undefined): string => (status ? (STAND[status] ?? status) : '—');
